module.exports = "<div class=\"flex-row align-items-center\">\n  <div class=\"container mt-2\">\n    <signin (signin)=\"onSignin()\"></signin>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/account/signin-page/signin-page.component.html
// module id = ../../../../../src/app/account/signin-page/signin-page.component.html
// module chunks = 6